import { Code2, BrainCircuit, ShieldCheck, Boxes, Banknote, FileCheck, Network } from "lucide-react";
import { PageHero, SectionHead, Reveal, Card, usePageMeta } from "@/components/primitives";
import EnquiryForm from "@/components/EnquiryForm";
import { DEPARTMENTS } from "@/lib/data";

const ICONS = { Code2, BrainCircuit, ShieldCheck, Boxes, Banknote, FileCheck, Network };

const CULTURE = [
  { title: "Craft Over Speed", body: "Financial infrastructure is judged in decades. We build accordingly." },
  { title: "Ownership", body: "Small teams, real responsibility, direct line to the founders." },
  { title: "Integrity Before Growth", body: "We would rather be trusted by fewer people than impressive to more." },
];

export default function Careers() {
  usePageMeta(
    "Careers | Avyagrah Tech Innovations",
    "Join Avyagrah Tech Innovations in building safer, smarter and more inclusive financial infrastructure for Bharat — engineering, AI/ML, cybersecurity, product, FinTech, compliance and operations."
  );
  return (
    <>
      <PageHero
        eyebrow="Careers"
        lines={["Build What Matters."]}
        lead="Join us in building safer, smarter and more inclusive financial infrastructure for Bharat."
      />

      <section className="border-b border-line py-24 sm:py-32" data-testid="careers-culture">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <SectionHead eyebrow="How We Work" title="An Engineer's Company With a Grassroots Heart" />
          <div className="mt-14 grid gap-5 sm:grid-cols-3">
            {CULTURE.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.07}>
                <Card testid={`culture-card-${i}`} className="h-full p-7">
                  <h3 className="font-display text-lg font-semibold text-mist">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mute">{c.body}</p>
                </Card>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-abyss/50 py-24 sm:py-32" data-testid="careers-departments">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <SectionHead
            eyebrow="Opportunities"
            title="Seven Tracks, One Mission"
            lead="We're assembling our founding team across these tracks. If a specific role isn't listed yet, express interest — we read every application."
          />
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {DEPARTMENTS.map((d, i) => {
              const Icon = ICONS[d.icon];
              return (
                <Reveal key={d.title} delay={i * 0.05} className={i === 6 ? "lg:col-span-3 lg:max-w-[calc(33.333%-0.75rem)]" : ""}>
                  <Card testid={`department-card-${i}`} className="group h-full p-7">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-line bg-abyss text-teal transition-colors duration-300 group-hover:border-teal/50">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-5 font-display text-lg font-semibold text-mist">{d.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-mute">{d.body}</p>
                  </Card>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32" data-testid="careers-form-section">
        <div className="mx-auto max-w-4xl px-6">
          <SectionHead eyebrow="View Opportunities" title="Express Interest" className="mb-12" center />
          <EnquiryForm
            defaultInterest="Careers"
            source="careers-page"
            heading="Careers Enquiry"
            lead="Tell us who you are, what you build, and why TimePe. We respond to every serious application."
            testid="careers-enquiry"
          />
        </div>
      </section>
    </>
  );
}
